/**
 * Report vocabulary for the detected things, per project mode.
 *
 * The model flow talks about detection *classes* (the classes a model was
 * trained on); the collection flow talks about detection *objects* (the objects
 * picked for a collection). Both render through the same PDF/DOCX generators, so
 * the wording travels on the export data rather than being hardcoded in the
 * templates, and each adapter declares which vocabulary its report speaks.
 *
 * `detectionClass` names only the *detected* thing. The Classification Summary
 * table's "Class" column means something different — the user's own filter
 * classes, e.g. "High density" — and stays "Class" in both modes.
 *
 * @module reportLabels
 */

export const MODEL_REPORT_LABELS = Object.freeze({
	detectionClasses: 'Detection Classes',
	detectionClass: 'Class',
});

export const COLLECTION_REPORT_LABELS = Object.freeze({
	detectionClasses: 'Detection Objects',
	detectionClass: 'Object',
});
